module.exports = __webpack_public_path__ + "static/media/lottery-prizes-mobile-small@2x.65b9832a.png";